<template>
    <v-container id="DetalleReporte">
        <div v-if="showcargando == true" id="cargando" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
            <div class="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>

        <div v-show="showLightbox">
            <LightBox ref="lightbox" :media="media" :show-caption="true" :show-light-box="false"
                @onClosed="CerrarVisor()" />
        </div>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-layout row wrap>
            <v-flex xs12 sm6 md4>
                <v-card style="background-color: transparent !important" width="100%">
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Abogado</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <vs-list-item style="padding-left:5px !important" title="Nombre: "
                                    :subtitle="this.detalleReporteData.prnombre">

                                    <v-row class="btnsAbo">
                                        <template v-if="this.detalleReporteData.medallaUrl != 'NA'">
                                            <div class="media-middle media-right" style="padding-left:0px">
                                                <img class="sq-100 btnMedalla"
                                                    :src="this.detalleReporteData.medallaUrl" />
                                            </div>

                                        </template>

                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">


                                                <v-btn v-on="on" v-bind="attrs" class="btnAbo" icon fab
                                                    @click="VistaProveedor(detalleReporteData.prclave)">
                                                    <v-icon class="btnCar" color="white">
                                                        mdi-account
                                                    </v-icon>
                                                </v-btn>

                                            </template>
                                            <span>Ver detalle</span>
                                        </v-tooltip>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">


                                                <v-btn v-on="on" v-bind="attrs" class="btnAboNew" icon fab
                                                    @click="VistaProveedorNewWindow(detalleReporteData.prclave)">
                                                    <v-icon class="btnsmall" color="white" size="12">
                                                        mdi-open-in-new
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Abrir en una nueva ventana</span>
                                        </v-tooltip>
                                    </v-row>

                                </vs-list-item>
                                <v-card-text>
                                    <span><a @click="Reasignaciones()">Reasignaciones</a></span>
                                </v-card-text>
                            </vs-list>
                        </v-card-text>
                    </v-card>
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Aseguradora</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <vs-list-item title="Aseguradora: " :subtitle="this.detalleReporteData.clnombre">

                                    <v-tooltip top
                                        v-if="detalleReporteData.clrutacontrato != null && detalleReporteData.clrutacontrato != ''">
                                        <template v-slot:activator="{ on, attrs }">

                                            <v-btn class="rounded-full btnAbo" icon dark v-on="on" v-bind="attrs"
                                                style="font-size: 20;" :loading="false" @click="VerContrato">
                                                <v-icon color>mdi mdi-file-document-multiple-outline</v-icon>
                                            </v-btn>

                                        </template>
                                        <span>Ver contrato</span>
                                    </v-tooltip>
                                </vs-list-item>
                                <vs-list-item title="Flotilla: "
                                    :subtitle="this.detalleReporteData.flnomcomp"></vs-list-item>
                            </vs-list>
                        </v-card-text>
                    </v-card>
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Titular</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <vs-list-item title="Póliza: "
                                    :subtitle="this.detalleReporteData.dapoliza"></vs-list-item>
                                <vs-list-item title="Nombre: "
                                    :subtitle="this.detalleReporteData.asnombre"></vs-list-item>
                                <vs-list-item title="Número de Membresía:"
                                    :subtitle="this.detalleReporteData.dacertificado"></vs-list-item>
                                <div v-if="!IsFuncionario">
                                    <vs-list-item id="correo" title="E-mail:"
                                        :subtitle="this.detalleReporteData.clcorreoalertas"></vs-list-item>
                                    <vs-list-item title="Inciso:"
                                        :subtitle="this.detalleReporteData.dainciso"></vs-list-item>
                                </div>
                                <vs-list-item title="Vigencia: "
                                    :subtitle="this.detalleReporteData.dafecfin"></vs-list-item>
                                <div v-if="IsFuncionario">
                                    <vs-list-item title="Cobertura: "
                                        :subtitle="this.detalleReporteData.dacobertura"></vs-list-item>
                                    <vs-list-item title="RFC del asegurado: "
                                        :subtitle="this.detalleReporteData.sarfc"></vs-list-item>
                                    <vs-list-item title="Suma asegurada: "
                                        :subtitle="this.detalleReporteData.sasumasegurada"></vs-list-item>
                                    <vs-list-item title="Monto pagado por la aseguradora:: "
                                        :subtitle="this.detalleReporteData.samontopagadoaseguradora"></vs-list-item>
                                    <vs-list-item title="Deducible: "
                                        :subtitle="this.detalleReporteData.sadeducible"></vs-list-item>
                                    <vs-list-item title="Coasegurado (Monto): "
                                        :subtitle="this.detalleReporteData.samontocoasegurado"></vs-list-item>
                                </div>
                            </vs-list>
                        </v-card-text>
                    </v-card>
                    <DatosContacto></DatosContacto>
                </v-card>
            </v-flex>
            <v-flex xs12 sm6 md4>
                <v-card style="background-color: transparent !important" width="100%">
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Asistencia</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <vs-list-item :subtitle="this.detalleReporteData.ainombre"></vs-list-item>
                            </vs-list>
                        </v-card-text>
                    </v-card>
                    <div v-if="!this.IsFuncionario">
                        <v-card flat class="text-xs-center ma-3">
                            <v-card-title class="justify-center primary">
                                <v-toolbar-title id="titulocard">
                                    Datos de la Demanda
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                                <vs-list>
                                    <vs-list-item title="Instancia:"
                                        :subtitle="this.detalleReporteData.insnombre"></vs-list-item>
                                    <vs-list-item title="Hospital Adscrito:"
                                        :subtitle="this.detalleReporteData.svdat3ro"></vs-list-item>
                                    <!--<vs-list-item
                      v-if="this.detalleReporteData.clclave == 'COM AM'"
                      title="Numero de siniestro:"
                      :subtitle="this.detalleReporteData.svnumsin"
                    ></vs-list-item>-->
                                    <v-list-item-content class="ms-1" v-if="editasiniestro">
                                        <!--Se quito this.detalleReporteData.clclave == 'COM AM' && -->
                                        <span class="text-subtitle">
                                            Numero de siniestro:
                                        </span>
                                        <p class="label-text2">
                                            <v-icon size="15" class="mr-1" v-if="validaEdicion && user == ''"
                                                v-on:click="Editar('numsin')">
                                                mdi-pencil
                                            </v-icon>
                                            {{ this.detalleReporteData.svnumsin }}
                                        </p>
                                    </v-list-item-content>
                                    <v-list-item-content class="ms-1" v-if="!editasiniestro">
                                        <span class="text-subtitle">
                                            No. de siniestro:
                                        </span>
                                        <div>
                                            <v-form ref="formsiniestros" v-model="valid" lazy-validation>
                                                <v-text-field class="mx-1" outlined autofocus
                                                    :rules="regex != '' ? ObtenerRegex() : [rules.required]"
                                                    :placeholder="user == '' ? place : ''" maxlength="20"
                                                    @keydown.enter.prevent v-on:blur="blurSiniestro()"
                                                    v-model="siniestro"></v-text-field>

                                                <v-row>
                                                    <v-spacer></v-spacer>
                                                    <v-icon v-on:click="Guardar('numsin')">
                                                        mdi-content-save
                                                    </v-icon>
                                                    <span> </span>
                                                    <v-icon v-on:click="Cancelar('numsin')" class="mr-4">
                                                        mdi-keyboard-return
                                                    </v-icon>
                                                </v-row>
                                            </v-form>
                                        </div>
                                    </v-list-item-content>
                                </vs-list>
                            </v-card-text>
                        </v-card>
                        <v-card flat class="text-xs-center ma-3">
                            <v-card-title class="justify-center primary">
                                <v-toolbar-title id="titulocard">Profesionista demandado</v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                                <vs-list>
                                    <vs-list-item title="Nombre:"
                                        :subtitle="this.detalleReporteData.svnomcond"></vs-list-item>
                                    <vs-list-item title="Especialidad:"
                                        :subtitle="this.detalleReporteData.espnombre"></vs-list-item>
                                    <vs-list-item title="El medico es:">
                                        <v-radio-group v-model="svtipo" row class="disable-action">
                                            <v-radio label="Eventual" :value="true"></v-radio>
                                            <v-radio label="Planta" :value="false"></v-radio>
                                        </v-radio-group>
                                    </vs-list-item>
                                </vs-list>
                            </v-card-text>
                        </v-card>
                        <v-card flat class="text-xs-center ma-3">
                            <v-card-title class="justify-center primary">
                                <v-toolbar-title id="titulocard">Datos del demandante</v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                                <vs-list>
                                    <vs-list-item title="Demandante:"
                                        :subtitle="this.detalleReporteData.svajustador"></vs-list-item>
                                    <vs-list-item title="Paciente:"
                                        :subtitle="this.detalleReporteData.svdirasco"></vs-list-item>
                                    <vs-list-item title="Monto de la demanda:"
                                        :subtitle="this.detalleReporteData.Svmonto"></vs-list-item>
                                </vs-list>
                            </v-card-text>
                        </v-card>

                    </div>

                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title v-if="this.IsFuncionario" id="titulocard">Siniestro</v-toolbar-title>
                            <v-toolbar-title v-else id="titulocard">Hechos</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <div v-if="this.IsFuncionario">
                                <vs-list>
                                    <vs-list-item title="Institución donde sucedió el incidente:"
                                        :subtitle="this.detalleReporteData.svdat3ro"></vs-list-item>
                                    <vs-list-item title="Estado donde sucedió:"
                                        :subtitle="this.detalleReporteData.esnombre"></vs-list-item>
                                </vs-list>
                            </div>
                            <vs-list>
                                <vs-list-item v-if="this.IsFuncionario" title="Localidad donde se atendió el siniestro:"
                                    :subtitle="this.detalleReporteData.lonombre"></vs-list-item>
                                <vs-list-item v-else title="Localidad:"
                                    :subtitle="this.detalleReporteData.lonombre"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item v-if="!this.IsFuncionario" title="Hospital:"
                                    :subtitle="this.detalleReporteData.svlughec"></vs-list-item>
                                <vs-list-item title="Descripcion:"></vs-list-item>
                                <v-textarea outlined v-model="this.detalleReporteData.svconversa" filled readonly
                                    rows="3">
                                </v-textarea>
                            </vs-list>
                        </v-card-text>
                    </v-card>
                    <DatosEjecutivo></DatosEjecutivo>
                </v-card>
            </v-flex>
            <v-flex xs12 sm6 md4>
                <v-card style="background-color: transparent !important" width="100%">
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Fechas</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <vs-list-item title="Siniestro:"
                                    :subtitle="this.detalleReporteData.svfhsiniestro"></vs-list-item>
                                <vs-list-item title="Reporte:"
                                    :subtitle="this.detalleReporteData.svfhreporte"></vs-list-item>
                                <vs-list-item title="Turnado:"
                                    :subtitle="this.detalleReporteData.svfhturnado"></vs-list-item>
                                <vs-list-item title="Estimada:"
                                    :subtitle="this.detalleReporteData.svfhestimada"></vs-list-item>
                                <vs-list-item v-if="detalleReporteData.svfhcontacto != '' && validaEdicion"
                                    title="Contacto:" :subtitle="this.detalleReporteData.svfhcontacto"></vs-list-item>
                                <v-list-item-content class="ms-1" v-if="detalleReporteData.svfhcontacto == ''">
                                    <span class="text-subtitle">
                                        Contacto:
                                    </span>
                                    <p class="label-text2" v-if="validaEdicion">
                                        <v-icon size="16" class="mr-1" v-if="editarfecha"
                                            v-on:click="Editar('contacto')">
                                            mdi-pencil
                                        </v-icon>
                                        <v-icon size="16" class="mr-1" v-if="!editarfecha"
                                            v-on:click="Guardar('contacto')">
                                            mdi-content-save
                                        </v-icon>
                                        <span> </span>
                                        <v-icon size="16" v-if="!editarfecha" v-on:click="editarfecha = !editarfecha"
                                            class="mr-1">
                                            mdi-keyboard-return
                                        </v-icon>
                                    </p>
                                    <div class="mt-2" v-if="!editarfecha">
                                        <span class="text-subtitle" v-if="PermisoSinIVR">
                                            Clave:
                                        </span>
                                        <span class="text-subtitle" v-else>
                                            Capturar IVR:
                                        </span>
                                        <div>
                                            <v-form ref="formcontacto" v-model="valid" lazy-validation>
                                                <v-text-field class="mx-1" outlined autofocus
                                                    :type="PermisoSinIVR ? 'password' : ''"
                                                    @keypress="PermisoSinIVR ? '' : filter($event)"
                                                    @keydown.enter.prevent :rules="[rules.required]"
                                                    v-on:blur="fhcontacto = fhcontacto.trim()"
                                                    v-model="fhcontacto"></v-text-field>
                                            </v-form>
                                        </div>
                                    </div>

                                </v-list-item-content>
                                <v-divider v-if="detalleReporteData.svfhcontacto == ''"></v-divider>
                                <vs-list-item v-if="detalleReporteData.svfhtermino != ''" title="Término:"
                                    :subtitle="this.detalleReporteData.svfhtermino"></vs-list-item>
                                <v-list-item-content class="ms-1" v-if="detalleReporteData.svfhtermino == ''">
                                    <span class="text-subtitle">
                                        Término:
                                    </span>
                                    <p class="label-text2"
                                        v-if="detalleReporteData.svfhcontacto != '' && validaEdicion">
                                        <v-icon size="16" class="mr-1" v-if="editarfecha"
                                            v-on:click="Editar('termino')">
                                            mdi-pencil
                                        </v-icon>
                                        <v-icon size="16" class="mr-1" v-if="!editarfecha"
                                            v-on:click="Guardar('termino')">
                                            mdi-content-save
                                        </v-icon>
                                        <span> </span>
                                        <v-icon size="16" v-if="!editarfecha" v-on:click="editarfecha = !editarfecha"
                                            class="mr-1">
                                            mdi-keyboard-return
                                        </v-icon>
                                    </p>
                                    <div class="mt-2" v-if="!editarfecha && detalleReporteData.svfhcontacto != ''">
                                        <v-form ref="formtermino" v-model="valid" lazy-validation>
                                            <span class="text-subtitle" v-if="PermisoSinIVR">
                                                Clave:
                                            </span>
                                            <span class="text-subtitle" v-else>
                                                Capturar IVR:
                                            </span>
                                            <div>

                                                <v-text-field class="mx-1" autofocus outlined
                                                    :type="PermisoSinIVR ? 'password' : ''"
                                                    @keypress="PermisoSinIVR ? '' : filter($event)"
                                                    :rules="[rules.required]" @keydown.enter.prevent
                                                    v-on:blur="fhcontacto = fhcontacto.trim()"
                                                    v-model="fhcontacto"></v-text-field>

                                            </div>
                                        </v-form>
                                    </div>
                                </v-list-item-content>
                                <v-divider v-if="detalleReporteData.svfhtermino == ''"></v-divider>
                                <vs-list-item title="Conclusión:"
                                    :subtitle="this.detalleReporteData.svfhconclusion"></vs-list-item>
                                <vs-list-item title="Cerrado:"
                                    :subtitle="this.detalleReporteData.svfhcerrado"></vs-list-item>
                            </vs-list>
                        </v-card-text>
                    </v-card>
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Prestación Otorgada</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <v-textarea outlined v-model="this.detalleReporteData.ptdesc" readonly filled rows="3">
                                </v-textarea>
                            </vs-list>
                        </v-card-text>
                    </v-card>
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Opciones</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-row align="center">
                                <v-col cols="12" sm="6">
                                    <h5>Control de Citas</h5>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <div class="text-center">
                                        <v-btn fab dark large color="success" @click="clickCitas">
                                            <v-icon dark>mdi-calendar-clock</v-icon>
                                        </v-btn>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row align="center" v-if="permisoWhats">
                                <v-col cols="12" sm="6">
                                    <h5>Whatsapp</h5>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <div class="text-center">
                                        <v-btn fab dark large color="success" @click="clickWhatsapp" stacked>
                                            <v-badge color="error" v-if="showDot">
                                                <v-icon dark>mdi-whatsapp</v-icon>
                                            </v-badge>
                                            <v-btn v-if="showDot == false" fab dark large color="success" dot
                                                @click="clickWhatsapp">
                                                <v-icon dark>mdi-whatsapp</v-icon>
                                            </v-btn>
                                        </v-btn>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Otros</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <h5 class="mt-2 ml-1"><a @click="Seguimiento()">Seguimiento</a></h5>
                        </v-card-text>
                    </v-card>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import Reporte from "@/services/RCMedico/RCMedico.service.js";
import DatosContacto from "@/components/pages/DatosDeContacto/DatosContacto.vue";
import DatosEjecutivo from "@/components/pages/DatosEjecutivo/DatosEjecutivo.vue";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import General from '@/services/ReporteGeneral/ReporteGeneral.service.js';
import WhatsappService from "@/services/Whatsapp/Whatsapp.service.js";
import '@/components/pages/Visor/dist/vue-image-lightbox.min.css';
import LightBox from '@/components/pages/Visor/LightBox.vue';
import ArchivosService from '@/services/Archivos/Archivos.service.js';

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        DatosContacto,
        DatosEjecutivo,
        LightBox
    },
    data: function () {
        return {
            showcargando: true,
            detalleReporteData: [],
            svlesiones: "",
            svavc: "",
            svaborto: "",
            svhomicidios: "",
            svavgc: "",
            svacta: "",
            svdpa: "",
            svfuga: "",
            svrecuperacion: "",
            svrobo: "",
            svtipo: false,
            IsFuncionario: false,
            showDot: false,
            permisoWhats: false,
            ///
            validaEdicion: false,
            precierre: false,
            permisolider: false,
            PermisoSinIVR: false,
            editarfecha: true,
            fhcontacto: '',
            datos: {},
            valid: true,
            rules: {
                required: value => !!value || 'Campo requerido',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Correo inválido'
                },
                monto: value => value > 15000 || 'Monto inválido',
            },
            editasiniestro: true,
            siniestro: '',
            user: '',
            regex: '',
            place: '',
            mensaje: '',
            historial: [],
            asistenciaurl: '',
            media: [{
                src: '@/',
                type: ''
            }],
            showLightbox: false,
            overlay: false,
            //certificado: [],
        };
    },

    computed: {
        ...mapState({ drawer: (state) => state.drawer }),
        ...mapState(["domain", "informationPage"]),
        DRAWER_STATE: {
            get() {
                return this.drawer;
            },
        },
    },
    async mounted() {
        this.showcargando = true;

        this.datos = await MetodosGenerales.obtenerSessionReporte("reporte");
        this.asistenciaurl = await MetodosGenerales.ObtenerURL(this.datos);
        this.changeReporteMenuOption("Detalle General");
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", this.datos.nrreporte);
        datosReporte.append("svindice", this.datos.svindice);
        //await General.ObtenerTipoCertificado(datosReporte).then(data => {
        //    this.certificado = data.result;
        //});
        await this.RevisarNotificacion();
        await this.DatosDetalle();
        await MetodosGenerales.HistorialBusqueda(this.datos, this.detalleReporteData.clnombrecorto);
        this.ValidaEditar();
        await MetodosGenerales.verificarPermisoSolo(
            this.domain.domainNameForApi,
            "VerificarPermiso",
            "358"
        ).then((response) => {
            if (response.data.length > 0) {
                this.permisoWhats = true;
            }
        });
    },
    methods: {
        ...mapMutations(["changeReporteMenuOption"]),
        blurSiniestro() {

            this.siniestro = this.siniestro = this.siniestro != null ? this.siniestro.trim() : null;

            const regex = new RegExp(this.regex); // Regex dinámica
            if (this.detalleReporteData.clclave == 'GSEG') {
                if (!regex.test(this.siniestro)) {
                    return;
                }
                else {

                    let dato = this.siniestro;

                    // Dividimos el dato en sus partes por el separador '/'
                    let partes = dato.split('/');

                    // Definimos las longitudes deseadas para cada segmento
                    let longitudes = [3, 3, 6, 4];

                    // Completamos cada parte al formato deseado
                    let datoFormateado = partes
                        .map((parte, index) => parte.padStart(longitudes[index], '0')) // Rellenamos con ceros a la izquierda
                        .join('/'); // Unimos nuevamente con '/'

                    this.siniestro = datoFormateado;
                }
            }
        },
        ObtenerRegex(value) {
            var resultRules = [];
            if (this.regex != '') {
                resultRules.push(
                    (v) => new RegExp(this.regex).test(v) || this.mensage
                );
                return resultRules;
            }
            else {
                return;
            }
        },
        async VistaProveedor(prclaveP) {

            let reporte = {
                nrreporte: String(this.datos.nrreporte),
                svindice: String(this.datos.svindice),
                aiclave: String(this.datos.aiclave),
                svfhconclusion: String(this.datos.svfhconclusion),
                prclave: String(prclaveP)

            };


            await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');

            this.$router.push({ name: 'DetalleAbogado' }).catch((error) => error);


        },
        async VistaProveedorNewWindow(prclaveP) {

            let reporte = {
                nrreporte: String(this.datos.nrreporte),
                svindice: String(this.datos.svindice),
                aiclave: String(this.datos.aiclave),
                svfhconclusion: String(this.datos.svfhconclusion),
                prclave: String(prclaveP)

            };


            await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');

            //this.$router.push({ name: 'DetalleAbogado' }).catch((error) => error);
            const routeData = this.$router.resolve({ name: 'DetalleAbogado' });
            window.open(routeData.href, '_blank');
        },
        async Guardar(dato) {
            let datos = [];
            if (dato == 'contacto') {
                this.fhcontacto = this.fhcontacto.trim();
                this.fhcontacto = this.fhcontacto.replace(/\s*$/, "");
                if (this.$refs.formcontacto.validate()) {
                    this.showcargando = true;
                    let formdata = new FormData();
                    formdata.append("nrreporte", this.datos.nrreporte);
                    formdata.append("svindice", this.datos.svindice);
                    formdata.append("clave", this.fhcontacto);
                    formdata.append("permiso", this.PermisoSinIVR);
                    formdata.append("uslogin", MetodosGenerales.ObtenerUserName());
                    await General.ActualizarContacto(this, formdata).then(data => {
                        if (data[0].success == 'true') {
                            this.DatosDetalle();
                            this.editarfecha = true;
                        }
                        else if (data[0].success == 'acceso') {
                            this.$swal(
                                "Atención",
                                data[0].mensaje,
                                "info"
                            );
                        }
                        else {
                            this.$swal(
                                "Atención",
                                data[0].mensaje,
                                "warning"
                            );
                        }
                        this.showcargando = false;
                    });
                }
            }
            else if (dato == 'termino') {
                this.fhcontacto = this.fhcontacto.trim();
                this.fhcontacto = this.fhcontacto.replace(/\s*$/, "");
                if (this.$refs.formtermino.validate()) {
                    this.showcargando = true;
                    let formdata = new FormData();
                    formdata.append("nrreporte", this.datos.nrreporte);
                    formdata.append("svindice", this.datos.svindice);
                    formdata.append("clave", this.fhcontacto);
                    formdata.append("svconlib", this.liberado);
                    formdata.append("permiso", "297");
                    formdata.append("uslogin", MetodosGenerales.ObtenerUserName());
                    await General.ActualizarTermino(this, formdata).then(data => {
                        if (data[0].success == 'true') {
                            this.DatosDetalle();
                            this.editarfecha = true;
                        }
                        else if (data[0].success == 'acceso') {
                            this.$swal(
                                "Atención",
                                data[0].mensaje,
                                "info"
                            );
                        }
                        else {
                            this.$swal(
                                "Atención",
                                data[0].mensaje,
                                "warning"
                            );
                        }
                        this.showcargando = false;
                    });

                }
            }
            else if (dato == 'numsin') {
                this.editasiniestro = false;
                this.siniestro = this.siniestro.trim();
                if (this.$refs.formsiniestros.validate()) {
                    this.showcargando = true;
                    let formdata = new FormData();
                    formdata.append("reporte", this.datos.nrreporte);
                    formdata.append("indice", this.datos.svindice);
                    formdata.append("numsiniestro", this.siniestro);
                    await General.GuardarNumSiniestro(this, formdata).then(data => {
                        if (data[0].success == 'true') {
                            this.DatosDetalle();
                            this.editasiniestro = true;
                        }
                        else {
                            this.$swal(
                                "Atención",
                                data[0].mensaje,
                                "warning"
                            );
                        }
                        this.showcargando = false;
                    });
                }
            }
        },
        async Editar(dato) {
            if (dato == 'contacto') {
                if (this.detalleReporteData.prclave.substring(0, 5) != 'PENDI') {
                    this.editarfecha = !this.editarfecha;
                    this.fhcontacto = '';
                }
                else {
                    this.$swal(
                        "Atención",
                        "El reporte debe de estar turnado para ingresar la fecha de Contacto",
                        "info"
                    );
                }
            }
            else if (dato == 'termino') {
                if (this.detalleReporteData.prclave.substring(0, 5) != 'PENDI') {
                    this.editarfecha = !this.editarfecha;
                    this.liberado = false;
                    this.fhcontacto = '';
                }
                else {
                    this.$swal(
                        "Atención",
                        "El reporte debe de estar turnado para ingresar la fecha de Término",
                        "info"
                    );
                }
            }
            else if (dato == 'numsin') {
                this.editasiniestro = !this.editasiniestro;
                this.siniestro = this.detalleReporteData.svnumsin;
            }
        },
        Cancelar(dato) {
            if (dato == 'numsin') {
                this.editasiniestro = !this.editasiniestro;
            }
        },
        async ValidaEditar() {

            var datosReporte = new FormData();
            datosReporte.append("reporte", this.datos.nrreporte);
            datosReporte.append("indice", this.datos.svindice);
            datosReporte.append("aiclave", this.datos.aiclave);
            await General.ValidarEdiccion(this, datosReporte).then(data => {
                if (data) {
                    this.validaEdicion = true;
                    this.validaposible = true;
                }

            });
            await General.Precierre(this, datosReporte).then(data => {
                this.precierre = data;
            });

            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '49, 297').then(response => {//ver pagos

                if (response.data.length > 0) {
                    response.data.forEach(object => {
                        if (object.peclave == 49)//Permiso lider
                            this.permisolider = true;
                        else if (object.peclave == 297)
                            this.PermisoSinIVR = true;
                    });
                }
            });
        },
        filter: function (evt) {
            evt = (evt) ? evt : window.event;
            let expect = evt.target.value.toString() + evt.key.toString();

            if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        async Reasignaciones() {

            this.datos.urlname = this.$route.name;
            await MetodosGenerales.guardarEnSesionInfoReporte(this.datos, 'reporte');
            this.$router.push({ path: this.asistenciaurl + '/Reasignacion' });
            //this.$router.push({ name: `ReasignacionRCMedico` });
        },
        async Seguimiento() {
            this.datos.urlname = this.$route.name;
            await MetodosGenerales.guardarEnSesionInfoReporte(this.datos, 'reporte');
            this.$router.push({ path: this.asistenciaurl + '/Seguimiento' });
            //this.$router.push({ name: `SeguimientoGeneralRCMedico` });
        },
        async clickCitas() {
            this.datos.urlname = this.$route.name;
            await MetodosGenerales.guardarEnSesionInfoReporte(this.datos, 'reporte');
            this.$router.push({ path: this.asistenciaurl + '/Reporte/Citas' });
            //this.$router.push({ name: 'citasRCMedico' });
        },
        clickWhatsapp() {
            this.$router.push({ name: "Whatsapp" });
        },
        async RevisarNotificacion() {
            let noti = await WhatsappService.Notification(this, this.datos);

            if (noti.result != null) {
                var isNot = noti.result.Datos[0].Column1;
                if (isNot == "1") {
                    this.showDot = true;
                }
            }
        },
        async DatosDetalle() {
            await Reporte.DatosDetalle(this, this.datos).then((data) => {
                let auxDetalleReporte = data[0];
                for (const [key, value] of Object.entries(auxDetalleReporte)) {
                    if (typeof value == "object") { auxDetalleReporte[key] = "" } else { auxDetalleReporte[key] = value.toString() }
                }

                this.detalleReporteData = auxDetalleReporte;
                this.svtipo = this.detalleReporteData.svtipo.toLowerCase() === "true";
                if (this.detalleReporteData.sarcfuncionarios == "2") {

                    this.IsFuncionario = true;
                } else {
                    this.IsFuncionario = false;
                }

                this.detalleReporteData.sasumasegurada = this.detalleReporteData.sasumasegurada == '' ? '' :
                    MetodosGenerales.regresarValorMoneda(
                        this.detalleReporteData.sasumasegurada,
                        "$"
                    );
                this.detalleReporteData.samontopagadoaseguradora = this.detalleReporteData.samontopagadoaseguradora == '' ? '' :
                    MetodosGenerales.regresarValorMoneda(
                        this.detalleReporteData.samontopagadoaseguradora,
                        "$"
                    );
                this.detalleReporteData.sadeducible = this.detalleReporteData.sadeducible == '' ? '' :
                    MetodosGenerales.regresarValorMoneda(
                        this.detalleReporteData.sadeducible,
                        "$"
                    );
                this.detalleReporteData.samontocoasegurado = this.detalleReporteData.samontocoasegurado == '' ? '' :
                    MetodosGenerales.regresarValorMoneda(
                        this.detalleReporteData.samontocoasegurado,
                        "$"
                    );



                let formdata = new FormData();
                formdata.append("nrreporte", this.datos.nrreporte);
                formdata.append("svindice", this.datos.svindice);
                formdata.append("clclave", this.detalleReporteData.clclave);
                General.ValidacionRegex(this, formdata).then(data => {
                    this.user = data[0].uslogin;
                    this.regex = data[0].regex;
                    this.place = data[0].place;
                    this.mensage = data[0].mensaje;
                });

                this.showcargando = false;
            });

        },
        async CerrarVisor() {
            var img = {
                src: '@/',
                type: 'img'
            }
            this.media = [];
            this.media.push(img);
            this.showLightbox = false;
            await this.$refs.lightbox.showImage(0);
        },
        async VerContrato() {
            this.showLightbox = false
            this.overlay = true;
            this.media = this.media.filter(obj => obj.src == '@/');

            let arr = this.detalleReporteData.clrutacontrato.split("/")
            let archivosResponse = await ArchivosService.ObtenerContrato(arr[0], arr[1])
                .catch((e) => {
                    console.log('error: ', e);
                })

            if (archivosResponse.error) {
                this.$swal({
                    position: 'center',
                    icon: "warning",
                    title: "Algo salió mal",
                    text: archivosResponse.msg,
                    showConfirmButton: true,
                    confirmButtonColor: '#536DFE',
                    confirmButtonText: 'Aceptar',
                    allowOutsideClick: false,
                    timer: 3000
                })

                this.overlay = false;
                return;
            }

            await this.RegistrarVisita(archivosResponse.archivo);

            let isPDF = /\.pdf$/i.test(archivosResponse.archivo);

            var file = {
                src: archivosResponse.watch,
                caption: '<h4> Contrato </h4>',
                type: isPDF ? 'pdf' : 'img',
                width: '800px',
                // docid: 123, 
                paginas: 1,
                archivo: archivosResponse.archivo
            };

            this.media.push(file);
            this.media = this.media.filter(obj => obj.src !== '@/');
            this.overlay = false;
            this.showLightbox = true
        },
        async RegistrarVisita(nombreArchivo) {
            var formData = new FormData();
            formData.append("lasitio", 'Prusia+');
            formData.append("lomodulo", 'RCMedico-ReporteDetalle');
            formData.append("laaccion", "Vio contrato");
            formData.append("lacaracteristicas", this.datos.nrreporte + '-' + this.datos.svindice);
            formData.append("lanombre", nombreArchivo);
            formData.append("ladestinatario", "");

            await ArchivosService.AlmacenarVisitas(formData);
        },
    },
};
</script>
<style scoped>
.text-subtitle {
    font-size: 12.8px;
    font-weight: 700;
}

.label-text2 {
    font-family: "Roboto", sans-serif;
    font-weight: 700 !important;
    font-size: 20px !important;
    margin-bottom: 0px !important;
}

.btnAbo {
    background-color: #536dfe;
    font-size: 20px !important;
    height: 40px !important;
    width: 40px !important;
    margin-left: 5px;
    /*margin-right: 10px;*/
}

.btnAboNew {
    background-color: #555;
    font-size: 100px !important;
    height: 20px !important;
    width: 20px !important;
}

.btnsAbo {
    flex-wrap: initial !important;
}

.btnMedalla {
    width: 40px;
    height: 40px;
    min-width: fit-content;
    margin-right: 15px
}


@media screen and (max-width: 1300px) {
    .btnMedalla {
        width: 40px;
        height: 40px;
        min-width: fit-content;
        margin-right: 35px
    }
}



@media screen and (max-width: 1400px) and (min-width: 1280px) {
    .btnMedalla {
        width: 40px;
        height: 40px;
        min-width: fit-content;
        margin-right: 35px;
        margin-left: 10px;
    }
}
</style>
<style lang="scss">
@media screen and (max-width: 700px) {
    #DatosGenerales .v-list-item__title {
        font-weight: 100;
        font-size: 0.9rem;
    }

    #DatosGenerales .vs-list--subtitle {
        font-size: 1rem;
        font-weight: 700;
    }
}

@media only screen and (min-width: 700px) and (max-width: 1060px) {
    #DatosGenerales .v-list-item__title {
        font-weight: 100;
        font-size: 1rem;
    }

    #DatosGenerales .vs-list--subtitle {
        font-size: 1.1rem;
        font-weight: 700;
    }
}

@media only screen and (min-width: 1060px) and (max-width: 1364px) {
    #DatosGenerales .v-list-item__title {
        font-weight: 100;
        font-size: 1rem;
    }

    #DatosGenerales .vs-list--subtitle {
        font-size: 1.1rem;
        font-weight: 700;
    }
}

@media only screen and (min-width: 1364px) and (max-width: 2004px) {
    #DatosGenerales .v-list-item__title {
        font-weight: 100;
        font-size: 1.2rem;
    }

    #DatosGenerales .vs-list--subtitle {
        font-size: 1.3rem;
        font-weight: 700;
    }
}

@media only screen and (min-width: 2004px) {
    #DatosGenerales .v-list-item__title {
        font-weight: 100;
        font-size: 1.3rem;
    }

    #DatosGenerales .vs-list--subtitle {
        font-size: 1.4rem;
        font-weight: 700;
    }
}

.disable-action {
    pointer-events: none;
}

#correo .list-titles {
    max-width: -webkit-fill-available !important;
}

.vue-lb-container {
    margin-top: 25px
}
</style>
